import styled, { css } from 'styled-components'
import { getDotStyles } from '../style'
import { DotsColorType } from '../type'

interface StyledDotProps {
    variant?: 'dark' | 'light'
    size?: 'small' | 'medium' | 'large'
    speed?: 'slow' | 'normal' | 'fast'
    color?: DotsColorType
}

const StyledDot = styled.div<StyledDotProps>(
    ({ theme, variant, size, speed, color }) =>
        getDotStyles({ theme, variant, size, speed, color })
)

export default StyledDot
